var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7514 6.53033C15.0443 6.23744 15.0443 5.76256 14.7514 5.46967L9.97844 0.696699C9.68555 0.403806 9.21068 0.403806 8.91778 0.696699C8.62489 0.989593 8.62489 1.46447 8.91778 1.75736L13.1604 6L8.91778 10.2426C8.62489 10.5355 8.62489 11.0104 8.91778 11.3033C9.21068 11.5962 9.68555 11.5962 9.97844 11.3033L14.7514 6.53033ZM0 6.75H14.2211V5.25H0V6.75Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/arrow_right_icon.268a8cbb3fa72899a512f42e2d61db61.svg";
export { ForwardRef as ReactComponent };